module.exports = __webpack_public_path__ + "c4b692371ae62dc49cd627d2a87104e6.svg";